import React from 'react';
import PropTypes from 'prop-types';

// material-ui
import {
    Button,
    CardContent,
    CardActions,
    Divider,
    Grid,
    IconButton,
    Modal,
    TextField,
    FormHelperText,
    Typography,
    Box,
    Autocomplete,
    FormLabel,
    Chip,
    Checkbox,
    ListItemText,
    Stack
} from '@mui/material';
import { IconUserCircle } from '@tabler/icons';
import CloseIcon from '@mui/icons-material/Close';
import { AccountCircle } from '@mui/icons-material';

function ViewComplexUsersModal({ open, onClose, users }) {
    return (
        <Modal open={open} onClose={onClose} aria-labelledby="view-users-title" aria-describedby="view-users-description">
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: 300, md: 500 },
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography id="view-users-title" variant="h3">
                        Users
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>
                {users.length > 0 ? (
                    <Grid container spacing={0.5}>
                        {users.map((u) => (
                            <Grid key={u.user.id} item xs={12}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center'
                                        // p: 1,
                                        // border: '1px solid #ccc',
                                        // borderRadius: 1
                                    }}
                                >
                                    <AccountCircle sx={{ fontSize: 48 }} />
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            p: 1
                                        }}
                                    >
                                        <Typography variant="body2">
                                            {u.user.firstName} {u.user.lastName}
                                        </Typography>
                                        <Typography variant="caption">{u.user.roleName}</Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <Typography variant="body2" color="textSecondary">
                        No Users Added Yet
                    </Typography>
                )}
            </Box>
        </Modal>
    );
}

ViewComplexUsersModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    users: PropTypes.array.isRequired
};

export default ViewComplexUsersModal;
